/**
 * Licensed Materials - Property of IBM
 * 5737-M66, 5900-AAA, 5900-A0N, 5725-S86, 5737-I75
 * © Copyright IBM Corp. 2020, 2023 All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication, or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import keyBy from 'lodash/keyBy';
import merge from 'lodash/merge';

export const defaultFetchState = { data: {}, fetchingData: false };
export const reduceFetchedData = (
  state = defaultFetchState,
  action,
  startFetchActionName,
  successfulFetchActionName,
  failedFetchActionName,
  successfulFetchDetailsActionName,
  keyField = 'name'
) => {
  switch (action.type) {
    case startFetchActionName:
      return {
        ...state,
        fetchingData: true,
        fetchDataError: null,
      };
    case failedFetchActionName:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: action.payload,
      };
    case successfulFetchActionName:
      return {
        ...state,
        fetchingData: false,
        fetchDataError: null,
        data: keyBy(action.payload, keyField),
      };
    case successfulFetchDetailsActionName:
      return merge(
        {},
        state,
        {
          fetchingData: false,
          fetchDataError: null,
        },
        {
          data: {
            [action.id]: action.payload,
          },
        }
      );
    default:
      return state;
  }
};

export const reduceUpdateData = (
  state = { data: {}, updatingData: false },
  action,
  startUpdateActionName,
  successfulUpdateActionName,
  failedUpdateActionName
) => {
  switch (action.type) {
    case startUpdateActionName:
      return {
        ...state,
        updatingData: true,
        updateDataError: null,
      };
    case failedUpdateActionName:
      return {
        ...state,
        updatingData: false,
        updateDataError: action.payload,
      };
    case successfulUpdateActionName:
      return merge(
        {},
        state,
        {
          updatingData: false,
          updateDataError: null,
        },
        {
          data: {
            [action.payload.id]: action.payload,
          },
        }
      );
    default:
      return state;
  }
};
